import React from "react";
import {Box, createTheme, IconButton, ThemeProvider, Typography,} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import {makeStyles} from "@mui/styles";
import {themeOptions} from "../../theme";
import {useSelector} from "react-redux";

const useStyles = makeStyles(() => ({
    mainInput: {
        position: "relative",
        minWidth: "200px",
    },
    inputField: {
        border: "1px solid #C4C4C4",
        borderRadius: "5px",
        fontSize: "14px !important",
        outline: "none",
        marginLeft: "4px",
        color: "#000",
        width: "100%",
        height: "100%",
        padding: "10px 0px 10px 30px",
        "&:focus": {
            border: "1px solid black",
        },
    },
    searchIcon: {
        color: "#C4C4C4",
        position: "absolute",
        top: "50%",
        left: "10%",
        transform: "translate(-50%,-50%)",
    },
    addIconBtn: {
        backgroundColor: "#06623B !important",
        marginLeft: "10px !important",
        color: "#fff !important",
    },
}));

export default function Index(props) {
    const {headerTitle, display, cbOpenModal, onSearch, onSearchPress} = props;
    const classes = useStyles();
    const theme = createTheme(themeOptions);

    const {role} = useSelector((state) => state.userDetailsReducer);

    return (
        <ThemeProvider theme={theme}>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{padding: "0px 25px"}}
                flexDirection={{xs: "column", md: "row"}}
            >
                <Typography variant="h6" sx={{fontWeight: "700 !important"}}>
                    {headerTitle}
                </Typography>

                <Box display="flex" marginTop={{xs: "10px", md: 0}}>
                    <Box className={classes.mainInput}>
                        <SearchIcon className={classes.searchIcon}/>
                        <input
                            type="text"
                            placeholder="Search"
                            className={classes.inputField}
                            onChange={(e) => onSearch(e.target.value)}
                        />
                    </Box>

                    {(role === "admin" || role === "super") && cbOpenModal && (
                        <IconButton
                            className={classes.addIconBtn}
                            onClick={() => cbOpenModal()}
                            size="medium"
                        >
                            <AddIcon fontSize="medium"/>
                        </IconButton>
                    )}
                </Box>
            </Box>
        </ThemeProvider>
    );
}
